var _ellipse, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinOfflineInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 45,
    viewBox: "0 0 29 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5,
    cy: 41.6406,
    rx: 10.6333,
    ry: 2.5625,
    fill: "url(#paint0_radial_1304_281656)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.35C29 6.355 22.5786 0 14.5 0C6.42143 0 0 6.355 0 14.35C0 25.01 14.5 41 14.5 41C14.5 41 29 25.01 29 14.35Z",
    fill: "#727E84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 39.4835C14.1193 39.0412 13.609 38.4378 13.0091 37.7027C11.6625 36.0527 9.86867 33.7447 8.07688 31.1101C6.28312 28.4727 4.50396 25.5263 3.17638 22.5983C1.84248 19.6564 1 16.8094 1 14.35C1 6.91706 6.96388 1 14.5 1C22.0361 1 28 6.91706 28 14.35C28 16.8094 27.1575 19.6564 25.8236 22.5983C24.496 25.5263 22.7169 28.4727 20.9231 31.1101C19.1313 33.7447 17.3375 36.0527 15.9909 37.7027C15.391 38.4378 14.8807 39.0412 14.5 39.4835Z",
    stroke: "#424E54",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28644 9.51968L8.37778 10.423L10.1629 12.1975H9.89222C7.95244 12.4025 6.44444 14.0361 6.44444 16.0156C6.44444 18.1361 8.178 19.8594 10.3111 19.8594H17.8704L19.1593 21.1406L20.068 20.2373L9.28644 9.51968ZM21.9111 16.6562C21.9111 14.965 20.59 13.5941 18.9144 13.4787C18.4762 11.2686 16.5236 9.60937 14.1778 9.60937C13.3207 9.60937 12.5216 9.84 11.8256 10.2308L20.7511 19.097C21.4536 18.5077 21.9111 17.6428 21.9111 16.6562Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1304_281656",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5 41.6406) rotate(90) scale(2.5625 10.6333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424E54",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424E54",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOfflineInactive);
export default __webpack_public_path__ + "static/media/Pin_Offline_Inactive.1cb4f39c99fb107b72639a952638533a.svg";
export { ForwardRef as ReactComponent };